export const ERROR_FETCHING_ACCOUNTS = "Failed to fetch accounts. Please try again.";
export const NOT_CONNECTED_ERROR = "LeadsLift is not connected. Please connect to LeadsLift first.";